// Dependencies
import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Components
import { Loading } from 'components/loadings'
import { PriceTableCard } from 'components/PriceTableCard'
import { ScreenWidthRender } from 'components/utilities/screen-width-render'

// Styles
import {
  Content,
  TitleWrapper,
  Title,
  PricetablesWrapper,
  Container
} from './pricetable-section.styles'
import 'swiper/css'

// Utils
import { priceCardData } from './pricetable-section.data'

export const PricetableSection: React.FC = () => {
  const [priceTable, setPriceTable] = useState<any>(null)

  useEffect(() => {
    setPriceTable(priceCardData)
  }, [])

  if (!priceTable) return <Loading />

  const renderPriceTableCard = (priceTableData: any, key: number) => (
    <PriceTableCard
      key={key}
      benefitsSummary={priceTableData.benefitsSummary}
      virtualAssistantChipLabel={priceTableData.virtualAssistantChipLabel}
      courseInformationLabel={priceTableData.courseInfoLabel}
      virtualAssistantLabel={
        !!priceTableData.hasVirtualAssistent
          ? 'Assistente virtual de estudos'
          : undefined
      }
      tooltipHelperMessage={priceTableData.tooltipHelperMessage}
      chipLabel={priceTableData.chipLabel}
      discount={
        !!priceTableData.isCurrency
          ? `R$ ${priceTableData.discount} OFF`
          : `${priceTableData.discount}% OFF`
      }
      knowMoreLabel={priceTableData.knowMoreLabel}
      buttonLabel={priceTableData.buttonLabel}
      variant={priceTableData.theme}
      listItems={priceTableData.listContent}
      mainPrice={priceTableData.mainContent}
      title={priceTableData.firstTitle}
      strikeThroughPriceLabel={priceTableData.strikeThroughPriceLabel}
      additionalStrikeThroughPriceLabel={
        priceTableData.additionalStrikeThroughPriceLabel
      }
      handleActionButtonClick={() => window.open(priceTableData.mainButtonHref)}
      handleKnowMoreClick={() => window.open(priceTableData.plusLink)}
    />
  )

  const priceTableCards = priceTable.priceCards.map(
    (priceTableData: any, index: number) =>
      renderPriceTableCard(priceTableData, index)
  )

  const swiperContent = (
    <Swiper
      spaceBetween={8}
      slidesPerView={1.1}
      breakpoints={{ 768: { spaceBetween: 24, slidesPerView: 2.1 } }}
      modules={[Navigation]}
      className="my-swipper"
    >
      {priceTable.priceCards.map((priceTableData: any, index: number) => (
        <SwiperSlide key={index}>
          {renderPriceTableCard(priceTableData, index)}
        </SwiperSlide>
      ))}
    </Swiper>
  )

  return (
    <Container>
      <Content>
        <TitleWrapper>
          <Title>{priceTable?.sectionTitle}</Title>
        </TitleWrapper>

        <PricetablesWrapper>
          <ScreenWidthRender
            renderingWidth={1024}
            actionAfterRenderingWidth="hide"
            content={swiperContent}
          />

          <ScreenWidthRender
            renderingWidth={1024}
            actionAfterRenderingWidth="show"
            content={
              <ScreenWidthRender
                renderingWidth={1366}
                actionAfterRenderingWidth="hide"
                content={swiperContent}
              />
            }
          />

          <ScreenWidthRender
            renderingWidth={1366}
            actionAfterRenderingWidth="show"
            content={priceTableCards}
          />
        </PricetablesWrapper>
      </Content>
    </Container>
  )
}
